import script from "./ProductVariantView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductVariantView.vue?vue&type=script&setup=true&lang=ts"

import "./ProductVariantView.vue?vue&type=style&index=0&id=0dc3a67e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dc3a67e"]])

export default __exports__